export const type = 'clearNewProduct';

const clearNewProduct = () => ({
    type,
    payload: undefined,
});

export default clearNewProduct;